import { setAssetPath } from '@esri/calcite-components';
import { defineCustomElements } from '@esri/calcite-components/loader';

const CALCITE_ASSET_PATH = 'https://js.arcgis.com/calcite-components/5.1.2/' as const;

export function registerCalciteComponents(): void {
  setAssetPath(CALCITE_ASSET_PATH);
  void defineCustomElements(window);
}
